"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_driver_1 = require("./time-driver");
var mock_time_source_1 = require("./mock-time-source");
function mockTimeSource(args) {
    return mock_time_source_1.mockTimeSource(args);
}
exports.mockTimeSource = mockTimeSource;
function timeDriver(_, adapter) {
    return time_driver_1.timeDriver(_, adapter);
}
exports.timeDriver = timeDriver;



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/@cycle/time/dist/index.js
// module id = ../../../node_modules/@cycle/time/dist/index.js
// module chunks = 1